// https://kcd.codes/koreacreditdata/market-buyer-frontend/pull/1182#discussion_r26996
// undefined를 쓰면 값을 주지 않아서, adhub 필터링에 걸리지 않는 값인 -1 셋팅이 필요함
export const INITIAL_BUSINESS_PUBLIC_ID = '-1';
